const maintenance = {
  on: "iizenglish est en maintenance pour quelques minutes.",
  details: "Veuillez rafraîchir la page dans quelques instants.",
  futureUpdateBannerMsg:
    "Une mise à jour d'iizenglish sera opérée le {date}, iizenglish sera indisponible pour quelques minutes.",
};

export default maintenance;
